import { render } from "./auditRefuse.vue?vue&type=template&id=c35637e0&scoped=true"
import script from "./auditRefuse.vue?vue&type=script&lang=js"
export * from "./auditRefuse.vue?vue&type=script&lang=js"

import "./auditRefuse.vue?vue&type=style&index=0&id=c35637e0&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c35637e0"]])

export default __exports__